import React from 'react';
import { Layout, Button, Row, Col, Tabs, Icon, Divider } from 'antd';
import style from './Login.css';
import LoginForm from './LoginForm';
import { Modal } from 'antd';

import { browserHistory } from 'react-router';
// import logo from './mnLogo.png'
import logo from './240x35蒙牛登录.png'

import codeImg from './code.png'
// 测试cfca
// import cfca from '../../cfca/ccie/index'

const { Header, Footer, Content } = Layout;
const TabPane = Tabs.TabPane;

class Login extends React.Component {
    // registerBtn(){
    //     tool.sgiLogger.info('registerBtn');
    //     browserHistory.push({
    //         pathname: '/register',
    //         state: { from: 'login' }
    //     });
    // }
  constructor(props) {
    super(props);
    this.state = {toggle: false};
  }
  testcfca() {
    cfca.verifyCertificate((res)=>{
        console.log(res)
      })
  }
  componentDidMount() {
        // console.log('ooooooooooo')
    this.warning();
  }

  QRCodeRefresh() {
    tool.sgiLogger.info('QRCodeRefresh')
  }

  tabsChange() {
    tool.sgiLogger.info(this.props.router);
    tool.sgiLogger.info('tabsChange')
  }
  toggleClick(bool) {
    this.setState({toggle: !bool})
  }
  warning(text){
    Modal.warning({
        className:style.checkInfoModal_index,
        title: '迁移通知',
        okButtonProps: {
            style: {display:'none'},
          },
        content: <div className={style.overflowHidden_index } style={{webkitBoxOrient:`vertical`}}>
            尊敬的平台用户：
            <br/>
为提升系统性能及加强安全性，计划于‌2025年7月11日（周五）17:00至2025年7月12日（周六）09:00‌进行系统迁移工作。在此期间保理系统所有功能将暂停服务‌。待迁移完成后，保理系统将启用‌新的访问地址‌：<a style={{ fontSize: '18px' }} href="https://nxr.mengniu.cn:7443">https://nxr.mengniu.cn:7443</a>。
<br/>
<br/>
请您提前做好相关安排，对于此次维护给您带来的不便，我们深表歉意，并感谢您的理解与支持。
          </div>,
      });
  } 
  render() {
    let toggle = this.state.toggle
    return (
            <Layout className={style.loginLayout}>
                <Header className={style.loginHeader}>
                    <div className={style.loginTitle}>
                        {/* <img className={style.loginTitleImg}
                            src={logo}
                            alt="" /> */}
                    </div>
                </Header>
                <Content className={style.loginContent}>
                    <div className={style.loginArea}>
                        <div onClick={() => this.toggleClick(toggle)} className={style.toggleBtn}>
                            <Icon className={style.toggleIcon} type={toggle?"right":'left'} />
                        </div>
                        <div className={style[toggle?'loginAreaLeft':'loginAreaLeft_hidden']}>
                            <h2> <span className={style.zllogo}></span>温馨提示</h2>
                            <div style={{padding:'20px 13px'}}>您当前的系统环境</div>
                            <div className={style.proposal}>
                                <div>
                                    1、浏览器：强烈推荐<span style={{color:'#c04323', fontSize:'13px'}}>Chrome</span>
                                    <span className={style.check}>√</span>
                                    {/* <Icon className={style.check} type="check" /> */}
                                </div>
                                <div>
                                    2、操作系统： <span style={{color:'#c04323', fontSize:'13px'}}>Windows 系统</span>
                                    <span className={style.check}>√</span>
                                </div>
                                <div>
                                    3、CFCA Chrome插件： 
                                    <a href="/assets/CryptoKit.COFCO.zip" download="CryptoKit.COFCO.zip">
                                        CryptoKit.COFCO.zip(点击下载)
                                    </a>
                                    <span className={style.check}>√</span>
                                </div>
                            </div>
                            <div className={style.tip}>
                                请对环境进行升级后，重新打开浏览器进行访问
                            </div>
                        </div>
                        <div className={style.loginAreaRight}>
                            <div className={style.formTitle}>蒙元保理资产管理平台</div>
                            {/* <div className={style.formSubTitle}>反向保理系统</div> */}
                            <LoginForm />
                        </div>
                    </div>
                </Content>
                <Footer className={style.loginFooter}>
                    <div className={style.Footer_content}>
                        <img src={codeImg}></img>
                        <a href={'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12010102001167'} target="_blank">津公网安备12010102001167号</a>
                        <a href={'https://beian.miit.gov.cn/#/Integrated/index'} target="_blank">津ICP备2023004811号-7</a> 
                    </div>
                </Footer>
            </Layout>
      )
  }
}

export default Login;


// WEBPACK FOOTER //
// ./apps/pages/login/Login.js